import {
  ChatBubbleLeftEllipsisIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  PencilIcon,
} from '@heroicons/react/24/outline';
import InformationCardRow from './InformationCardRow';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import CommentBox from '../../comments/CommentBox';

const InformationCard = ({
  type,
  buyerReviewScreen,
  supplierReviewScreen,
  makersharksReviewScreen,
  RFQOverviewMakersharksScreen,
}) => {
  const information = useSelector(
    (state) => state?.quoteReducer?.quote?.[type],
  );
  const [editing, setEditing] = useState(false);
  const [comments, setComments] = useState(true);
  const [data, setData] = useState(information?.data);
  const [collapsed, setCollapsed] = useState(true);
  const heading = information?.heading;

  return (
    <div className="min-w-screen">
      <div className="block p-5 pl-10 bg-white border border-[#DDDDDD] rounded-2xl">
        <div
          className="flex justify-between hover:cursor-pointer"
          onClick={() => setCollapsed(!collapsed)}
        >
          <h5 className="text-2xl tracking-tight text-gray-900 text-[25px]">
            {heading}
          </h5>
          <div className="flex flex-row space-x-2">
            {!buyerReviewScreen &&
              !supplierReviewScreen &&
              !makersharksReviewScreen &&
              !RFQOverviewMakersharksScreen && (
                <PencilIcon
                  className="block h-6 w-6 hover:cursor-pointer"
                  aria-hidden="true"
                  onClick={() => setEditing(!editing)}
                />
              )}
            {(supplierReviewScreen || RFQOverviewMakersharksScreen) && (
              <ChatBubbleLeftEllipsisIcon className="h-6 w-6 hover:cursor-pointer" />
            )}
            <button
              className="block h-6 w-6 hover:cursor-pointer"
              aria-hidden="true"
              onClick={() => setCollapsed(!collapsed)}
            >
              {!collapsed ? (
                <ChevronUpIcon className="h-6 w-6" />
              ) : (
                <ChevronDownIcon className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>
        {!collapsed && ( // Render content only if not collapsed
          <div className="flex">
            <div className="flex-col w-full">
              {data &&
                data.map((item) => (
                  <InformationCardRow
                    key={item.heading} // Make sure to add a unique key
                    editing={editing}
                    type={type}
                    heading={item.heading}
                  />
                ))}

              {comments && supplierReviewScreen && (
                <CommentBox heading={heading} />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InformationCard;
